import React, { useState } from "react";
import "./login.css";
import api from "../services";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./Auth";
import { resetAdminPassword } from "../apiCalls"; // Import the new function

export default function Login() {
    const navigate = useNavigate();
    const { login, user } = useAuth();

    const [view, setView] = useState("login"); // 'login' or 'forgot'
    const [form, setForm] = useState({ username: "", password: "" });
    const [forgotForm, setForgotForm] = useState({ email: "", dob: "", newPassword: "" });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    if (user) { navigate("/dashboard", { replace: true }); }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleForgotChange = (e) => {
        const { name, value } = e.target;
        setForgotForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("username", form.username);
            formData.append("password", form.password);

            const response = await api("post", "login", formData, false);
            if (response.status === "success") {
                sessionStorage.setItem("authToken", response.authToken);
                sessionStorage.setItem("refreshToken", response.refreshToken);
                login(response.authToken);
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError("Invalid Username or Password");
        } finally { setLoading(false); }
    };

    const handleResetSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            // 1. Convert YYYY-MM-DD to DD/MM/YYYY
            const [year, month, day] = forgotForm.dob.split("-");
            const formattedDob = `${day}/${month}/${year}`;

            // 2. Prepare the payload with the formatted date
            const payload = {
                ...forgotForm,
                dob: formattedDob
            };

            const res = await resetAdminPassword(payload);

            if (res.status) {
                setSuccess("Password reset successfully! Please login.");
                setView("login");
                // Reset form
                setForgotForm({ email: "", dob: "", newPassword: "" });
            } else {
                setError(res.message || "Verification failed.");
            }
        } catch (err) {
            setError("Information mismatch. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-wrapper overflow-hidden">
            <section className="bg-light-gray border-top border-primary border-4 d-flex align-items-center justify-content-center min-vh-100">
                <div className="container py-3">
                    <div className="sign-in card mx-auto shadow-lg" style={{ maxWidth: "400px" }}>
                        <div className="card-body py-4 px-4">
                            <h4 className="text-center mb-4">JU - Admin</h4>

                            {error && <div className="alert alert-danger py-2 small">{error}</div>}
                            {success && <div className="alert alert-success py-2 small">{success}</div>}

                            {view === "login" ? (
                                <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
                                    <input type="text" name="username" className="form-control" placeholder="Username / Email" value={form.username} onChange={handleChange} required />
                                    <input type="password" name="password" className="form-control" placeholder="Password" value={form.password} onChange={handleChange} required />
                                    <button type="submit" className="btn btn-dark w-100" disabled={loading}>{loading ? "Signing In..." : "Sign In"}</button>
                                    <p className="text-center mt-2 mb-0 small text-primary" style={{ cursor: 'pointer' }} onClick={() => setView("forgot")}>Forgot Password?</p>
                                </form>
                            ) : (
                                <form onSubmit={handleResetSubmit} className="d-flex flex-column gap-3">
                                    <p className="small text-muted">Verify your identity to reset password.</p>
                                    <input type="email" name="email" className="form-control" placeholder="Registered Email" value={forgotForm.email} onChange={handleForgotChange} required />
                                    <label className="small mb-0 ms-1 text-muted">Date of Birth</label>
                                    <input type="date" name="dob" className="form-control" value={forgotForm.dob} onChange={handleForgotChange} required />
                                    <input type="password" name="newPassword" className="form-control" placeholder="New Password" value={forgotForm.newPassword} onChange={handleForgotChange} required />
                                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>{loading ? "Verifying..." : "Reset Password"}</button>
                                    <p className="text-center mt-2 mb-0 small" style={{ cursor: 'pointer' }} onClick={() => setView("login")}>Back to Login</p>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}